import { useMutation } from '@tanstack/react-query';
import https from 'utils/https';
import { ENDPOINTS } from 'utils/endpoints/endpoints';
import { useGetFeedbackMutation } from './getFeedback';

async function patchFeedback({ input, id }) {
  const { data } = await https.patch(`${ENDPOINTS.FEEDBACK}/${id}`, input);

  return data;
}

export const usePatchReadMutation = () => {
  const { mutate: getFeedback } = useGetFeedbackMutation();
  return useMutation({
    mutationFn: ({ input, id }) => patchFeedback({ input, id }),
    onSuccess: data => {
      getFeedback();
    },
    onError: error => {
      console.log(error);
    }
  });
};
